<template>
  <div>
    <div>{{ field.label }}</div>
    <div class="red--text" v-for="error in errors" :key="error">
      {{ error }}
    </div>
    <v-layout v-show="error" @click="error = null">{{ error }}</v-layout>
    <v-layout class="mb-2">
      <v-flex xs6 sm4>
        <v-img
          :src="preview_image(updated)"
          ref="image"
          :max-width="field.max_width"
          :max-height="field.max_height"
          contain
        />
      </v-flex>
    </v-layout>
    <v-layout class="mb-4">
      <v-btn
        @click="openFileDialog()"
        :loading="loading"
        :disabled="loading"
        color="blue-grey"
        class="white--text"
      >
        Загрузить фото
        <v-icon right dark>cloud_upload</v-icon>
      </v-btn>
      <input
        class="image_upload"
        ref="image_input"
        type="file"
        accept="image/jpeg,image/png,image/gif"
        @change="onFileChange"
      />
    </v-layout>

    <v-dialog v-model="dialog" max-width="440">
      <v-card>
        <v-card-title class="headline">Удалить изображение?</v-card-title>

        <v-card-text>
          Изображение будет удалено с сервера
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="white darken-1" text @click="dialog = false">
            Отмена
          </v-btn>

          <v-btn color="red darken-1" text @click="deleteImage">
            Удалить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import images from "./../../api/images";
import config from "../../config";
import validators_mixin from "./../../mixins/validators.mixin";

export default {
  name: "ImageField",
  props: ["entity", "field", "value"],
  mixins: [validators_mixin],
  computed: {
    image_src: {
      get() {
        return this.image_base_source;
      },
      set(value) {
        this.image_base_source = value;
      }
    }
  },
  data() {
    return {
      image_name: this.value,
      image_base_source: null,
      updated: false,
      loading: false,
      dialog: false,
      error: null
    };
  },
  methods: {
    deleteImage() {
      this.dialog = false;
      this.delete_image_function(this.$parent.type, this.$parent.id);
    },
    preview_image(updated) {
      console.log("ImageField.preview_image", updated, this.entity);
      if (updated) {
        return this.image_base_source;
      } else if (this.entity.id || this.value) {
        console.log("preview image", this.field.url_pattern);
        const re = /{([\w\d]+)}/g;
        const url = this.field.url_pattern.replace(re, chunk => {
          const param = chunk.slice(1, -1);
          if (param === "filename") return this.value;
          return this.entity[param];
        });
        return config.imagesBaseUrl + url;
      }
    },
    clear() {
      this.errors = [];
      this.error = null;
    },
    showImage(image) {
      let image_read = new FileReader();
      image_read.onload = data => {
        this.updated = true;
        this.image_src = data.currentTarget.result;
      };
      image_read.readAsDataURL(image);
    },
    openFileDialog() {
      this.$refs.image_input.click();
    },
    async onFileChange(e) {
      console.log("ImageField.onFileChange");
      this.clear();
      let image = e.target.files[0];
      if (
        image.type === "image/jpeg" ||
        image.type === "image/png" ||
        image.type === "image/gif"
      ) {
        this.showImage(image);
        this.loading = true;
        this.$parent.entity[this.field.name] = image.name;

        const result = await images.upload(this.token, image);
        this.loading = false;
        if (!result.success) this.error = result.message;
        else {
          this.$parent.entity[this.field.name] = result.filename;
        }
      } else {
        this.error =
          "Расширение файла должно быть image/jpeg, image/png, image/gif";
      }
    },
    async delete_image_function(entity_type, entity_id) {
      const result = await images.delete(this.token, entity_type, entity_id);
      if (result.data.result === true) {
        this.loading = false;
      } else {
        this.loading = false;
        this.error = result.data.message;
      }
    }
  }
};
</script>

<style scoped>
.image_upload {
  display: none;
}
</style>
